/* global Headroom */

var nav = function () {

    // elements

    var element = document.querySelector('[data-nav]');
    var list = document.querySelector('[data-nav-list]');
    var secondaryNavs = document.querySelectorAll('[data-nav-secondary]');
    var tertiaryNavs = document.querySelectorAll('[data-nav-tertiary]');
    var quaternaryNavs = document.querySelectorAll('[data-nav-quaternary]');

    var togglingSecondary = document.querySelectorAll('[data-nav-toggling="secondary"]');
    var togglingTertiary = document.querySelectorAll('[data-nav-toggling="tertiary"]');
    var togglingQuaternary = document.querySelectorAll('[data-nav-toggling="quaternary"]');

    var togglingTertiaryDesktop;
    var secondaryClose;
    var backElements;

    var dimmer;

    var navItemsWithQuaternary;

    var html = document.getElementsByTagName('html')[0];
    var body = document.getElementsByTagName('body')[0];

    // settings

    var showDesktopNav = '(min-width: 980px)';
    var lastRenderingDesktop;
    var lastScrollTop = 0;
    var canHover = true;

    // instances

    var headroomInstance = false;

    // timers

    var closeTimer;
    var tabHoverTimer;

    // init()

    function init() {

        if (!element) { return; }

        navItemsWithQuaternary = returnNavItemsWithQuaternary();

        createTabs();
        createCloseLinks();
        createMobileElements();
        createDimmer();

        resetNav();
        window.addEventListener('resize', debounce(function () { resetIfEnvironmentChanged(); }, 500));

        window.addEventListener('resize', clearStylesOnResize);

        window.addEventListener('load', setNavListWidth);
        window.addEventListener('resize', debounce(function () { setNavListWidth(); }, 250));

        window.addEventListener('load', setNavHeights);
        window.addEventListener('resize', debounce(function () { setNavHeights(); }, 750));

        window.addEventListener('load', navClicks);

        lastRenderingDesktop = isDesktopNav();

        hideOnScroll();

        detectHover();

        //addScrollClue();

    }

    // hideScrollClue()

    //function hideScrollClue() {

    //    element.querySelector('.nav__inner').addEventListener('scroll', function () { element.classList.remove('nav--with-scroll-clue'); });

    //}

    // addScrollClue()

    //function addScrollClue() {

    //    if (!isDesktopNav()) {

    //        var windowWidth = window.innerWidth || document.documentElement.clientWidth;

    //        for (var i = 0; i < togglingSecondary.length; i++) {

    //            var bounding = togglingSecondary[i].getBoundingClientRect();

    //            if (bounding.right > windowWidth) {

    //                //element.classList.add('nav--with-scroll-clue');

    //                hideScrollClue();

    //                var elementPaddingLeft = parseInt(window.getComputedStyle(togglingSecondary[i], null).getPropertyValue('padding-left'));

    //                if (windowWidth - bounding.left < (elementPaddingLeft * 2)) {

    //                    element.classList.add('nav--with-scroll-clue');

    //                    hideScrollClue();

    //                }

    //                break;

    //            }

    //        }

    //    }

    //}

    // detectHover()

    function detectHover() {

        window.addEventListener('touchstart', function () { canHover = false; }, false);
        element.addEventListener('mouseover', debounce(function () { canHover = true; }, 500));

    }

    // hideOnScroll()

    function hideOnScroll() {

        if (!element.hasAttribute('data-nav-hide-on-scroll') || typeof Headroom === 'undefined' || !Headroom.cutsTheMustard) { return; }

        headroomInstance = new Headroom(element, {
            offset: 100
        });

        headroomInstance.init();

    }

    // resetIfEnvironmentChanged()

    function resetIfEnvironmentChanged() {

        if (isDesktopNav() !== lastRenderingDesktop) {

            resetNav();
            lastRenderingDesktop = isDesktopNav();

        } else {

            setNavHeights();

        }

    }

    // isDesktopNav()

    function isDesktopNav() {

        return matchMedia(showDesktopNav).matches;

    }

    // setupTertiary()
    // Ensure only the first tertiary item is shown on desktop - e.g. "Motor" under "Insurance"

    function setupTertiary() {

        for (var i = 0; i < navItemsWithQuaternary.length; i++) {

            // cache desktop items

            var desktopTertiaryItems = Array.prototype.slice.call(navItemsWithQuaternary[i].querySelectorAll('[data-nav-toggling="tertiary|desktop"]'));

            // make sure the first one is active

            resetItems([desktopTertiaryItems[0]], true);

            // apply appropriate style

            var startingStyle = desktopTertiaryItems[0].getAttribute('data-style');
            navItemsWithQuaternary[i].setAttribute('data-style', startingStyle);

            // remove the first item from the array

            desktopTertiaryItems.shift();

            // set all items other than the first to be hidden

            resetItems(desktopTertiaryItems, false);

        }

    }

    // setupTertiaryStyling()

    function setupTertiaryStyling() {

        for (var i = 0; i < navItemsWithQuaternary.length; i++) {

            var startingStyle = navItemsWithQuaternary[i].querySelectorAll('[data-nav-toggling="tertiary"]')[0].getAttribute('data-style');
            navItemsWithQuaternary[i].setAttribute('data-style', startingStyle);

        }

    }

    // resetItems()
    // Reset nav items so that they are correctly hidden or shown

    function resetItems(items, isShown) {

        for (var i = 0; i < items.length; i++) {

            var selector = '#' + items[i].getAttribute('aria-controls');

            var target = document.querySelector(selector);


            if (isShown) {

                items[i].setAttribute('aria-expanded', 'true');
                target.classList.add('is-shown');

            } else {

                items[i].setAttribute('aria-expanded', 'false');
                target.classList.remove('is-shown');

            }

        }

    }

    // resetNav()

    function resetNav() {

        element.classList.add('nav--no-animations');

        resetItems(togglingSecondary, false);

        setTimeout(function () {

            if (isDesktopNav()) {

                resetItems(togglingTertiary, true);
                resetItems(togglingQuaternary, true);

                setupTertiary();

            } else {

                resetItems(togglingTertiary, false);
                resetItems(togglingQuaternary, false);

                setupTertiaryStyling();

            }

            dimmer.classList.remove('is-shown');

            unlockScroll();

            setNavHeights();

        }, 100);

        setTimeout(function () { element.classList.remove('nav--no-animations'); }, 110);

        if (headroomInstance) { headroomInstance.unfreeze(); }

    }

    // clearStylesOnResize()
    // Immediately clear defined style on resize that cause layout issues

    function clearStylesOnResize() {

        list.style.width = null;
        //element.classList.remove('nav--with-scroll-clue');

    }

    // setNavListWidth()
    // Override the excessive width for the nav set in CSS with a calculated value

    function setNavListWidth() {

        if (isDesktopNav()) {

            list.style.width = 'auto';

        } else {

            var width = 0;
            for (var i = 0; i < togglingSecondary.length; i++) { width += togglingSecondary[i].getBoundingClientRect().width; }
            list.style.width = Math.ceil(width) + 'px';

        }

    }

    // setNavHeight()
    // Set the height of secondary nav items for mobile

    function setNavHeights() {

        if (isDesktopNav()) { return; }

        var height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        height -= element.getBoundingClientRect().top;

        var top;

        for (var i = 0; i < secondaryNavs.length; i++) { secondaryNavs[i].style.height = height + 'px'; }

        for (var j = 0; j < tertiaryNavs.length; j++) {

            top = parseInt(window.getComputedStyle(tertiaryNavs[j]).getPropertyValue('top')) || 0;
            tertiaryNavs[j].style.height = (height - top) + 'px';

        }

        for (var k = 0; k < quaternaryNavs.length; k++) {

            top = parseInt(window.getComputedStyle(tertiaryNavs[k]).getPropertyValue('top')) || 0;
            quaternaryNavs[k].style.height = (height - top) + 'px';

        }

    }

    // createTabs()
    // Create tabs for desktop navigation where necessary

    function createTabs() {

        for (var i = 0; i < navItemsWithQuaternary.length; i++) {

            var tabs = navItemsWithQuaternary[i].querySelectorAll('[data-nav-toggling="tertiary"]');
            var tabsArray = Array.prototype.slice.call(tabs);

            var container = document.createElement('div');
            container.setAttribute('class', 'nav__tabs is-injected');

            var containerInner = document.createElement('div');
            containerInner.setAttribute('class', 'nav__tabs__inner');

            for (var j = 0; j < tabsArray.length; j++) {

                var clone = tabsArray[j].cloneNode(true);
                clone.setAttribute('class', 'nav__tab');
                clone.setAttribute('data-nav-toggling', 'tertiary|desktop');
                containerInner.appendChild(clone);

            }

            container.appendChild(containerInner);

            var secondary = navItemsWithQuaternary[i].querySelector('[data-nav-secondary]');
            secondary.insertBefore(container, secondary.firstChild);

        }

        togglingTertiaryDesktop = document.querySelectorAll('[data-nav-toggling="tertiary|desktop"]');

    }

    // createClose()
    // Create close links used on desktop and mobile

    function createCloseLinks() {

        for (var i = 0; i < togglingSecondary.length; i++) {

            var selector = '#' + togglingSecondary[i].getAttribute('aria-controls');
            var target = document.querySelector(selector);


            var text = togglingSecondary[i].textContent;
            var closeText = 'Close<span class="nav__title__close__inner"> ' + text + ' navigation</span>';

            var titleElement = document.createElement('div');
            titleElement.setAttribute('class', 'nav__title is-injected');
            titleElement.innerHTML = '<span class="nav__title__text">' + text + '</span>';

            var clone = togglingSecondary[i].cloneNode(true);
            clone.setAttribute('class', 'nav__title__close nav__title__close--pressure');
            clone.removeAttribute('data-nav-toggling');
            clone.setAttribute('aria-expanded', 'true'); // when this element is visible the corresponding nav item is always expanded
            clone.setAttribute('data-nav-close', '');
            clone.innerHTML = closeText;

            titleElement.appendChild(clone);

            target.insertBefore(titleElement, target.firstChild);

        }

        secondaryClose = document.querySelectorAll('[data-nav-close]');

    }

    // createMobileElements()
    // Create additional elements required for mobile navigation

    function createMobileElements() {

        function returnTitle(text, navItem, type) {

            var titleElement = document.createElement('div');
            titleElement.setAttribute('class', 'nav__back is-injected');

            var clone = navItem.cloneNode(true);
            clone.setAttribute('class', 'nav__back__link');
            clone.removeAttribute('data-nav-toggling');
            clone.setAttribute('aria-expanded', 'true'); // when this element is visible the corresponding nav item is always expanded
            clone.setAttribute('data-nav-back', type);
            clone.innerHTML = text;

            titleElement.appendChild(clone);

            return titleElement;

        }

        function createBackElement(navItem, type) {

            var selector = '#' + navItem.getAttribute('aria-controls');

            var target = document.querySelector(selector);


            var backText = navItem.textContent;

            var titleElement;

            if (type === 'tertiarySkip') {

                var relevantQuaternaryNavs = target.querySelectorAll('[data-nav-quaternary]');

                for (var i = 0; i < relevantQuaternaryNavs.length; i++) {

                    titleElement = returnTitle(backText, navItem, 'tertiary|skip');
                    relevantQuaternaryNavs[i].insertBefore(titleElement, relevantQuaternaryNavs[i].firstChild);

                }

            } else {

                titleElement = returnTitle(backText, navItem, type);
                target.insertBefore(titleElement, target.firstChild);

            }

        }

        for (var i = 0; i < togglingTertiary.length; i++) { createBackElement(togglingTertiary[i], 'tertiary'); }
        for (var j = 0; j < togglingQuaternary.length; j++) { createBackElement(togglingQuaternary[j], 'quaternary'); }
        for (var k = 0; k < togglingTertiary.length; k++) { createBackElement(togglingTertiary[k], 'tertiarySkip'); }

        backElements = document.querySelectorAll('[data-nav-back]');

    }

    // createDimmer()
    // Create dimmer for desktop navigation

    function createDimmer() {

        var dimmerElement = document.createElement('div');
        dimmerElement.setAttribute('class', 'nav-dimmer is-injected');
        dimmerElement.setAttribute('data-nav-dimmer', '');

        document.getElementsByTagName('body')[0].appendChild(dimmerElement);

        dimmer = document.querySelector('[data-nav-dimmer]');

    }

    // navClicks()

    function navClicks() {

        // setStateAndScroll
        // Assigns the current nav state to a data attribute and scrolls all sections to the top

        function setStateAndScroll(type, expanded) {

            if (type === 'secondary' && !expanded) {

                element.setAttribute('data-nav', '');

            } else {

                if (expanded) {

                    element.setAttribute('data-nav', type);

                } else {

                    var result = (type === 'quaternary') ? 'tertiary' : 'secondary';
                    element.setAttribute('data-nav', result);

                }

            }

            for (var i = 0; i < secondaryNavs.length; i++) { secondaryNavs[i].querySelector('.nav__secondary__inner').scrollTop = 0; }
            for (var j = 0; j < tertiaryNavs.length; j++) { tertiaryNavs[j].scrollTop = 0; }
            for (var k = 0; k < quaternaryNavs.length; k++) { quaternaryNavs[k].scrollTop = 0; }

        }

        // toggle()

        function toggle(item, existing) {

            var expanded = item.getAttribute('aria-expanded') === 'true' ? true : false;

            var selector = '#' + item.getAttribute('aria-controls');
            var target = document.querySelector(selector);


            var isSecondary = item.getAttribute('data-nav-toggling') === 'secondary';

            if (expanded) {

                target.classList.remove('is-shown');
                dimmer.classList.remove('is-shown');

                if (isSecondary && headroomInstance) { headroomInstance.unfreeze(); }

                if (isSecondary && !isDesktopNav()) { setTimeout(function () { resetNav(); }, 250); }

            } else {

                if (isSecondary && isDesktopNav()) {

                    setupTertiary();
                    setupTertiaryStyling();

                }

                if (existing) {

                    existing.classList.remove('is-shown');
                    var link = document.querySelector('[aria-controls="' + existing.getAttribute('id') + '"]');

                    link.setAttribute('aria-expanded', false);

                }

                target.classList.add('is-shown');
                dimmer.classList.add('is-shown');

                if (isSecondary && headroomInstance) { headroomInstance.freeze(); }

                if (isSecondary && !isDesktopNav()) { lockScroll(); }

            }

            setStateAndScroll(item.getAttribute('data-nav-toggling'), !expanded);

            item.setAttribute('aria-expanded', !expanded);

        }

        // toggling secondary clicks / hovers

        function togglingSecondaryClick(e) {

            var existing = document.querySelector('[data-nav-secondary].is-shown');

            clearTimeout(closeTimer);

            toggle(e.target, existing);

            e.preventDefault();

        }

        function togglingSecondaryKeyDown(e) {

            var keyPressed = getKeyPressed(e);

            if (keyPressed === 13 || keyPressed === 'Enter') { togglingSecondaryClick(e); }

        }

        function togglingSecondaryHover(e) {

            if (isDesktopNav() && canHover) {

                clearTimeout(closeTimer);

                var existing = document.querySelector('[data-nav-secondary].is-shown');

                if (e.target.querySelector('[data-nav-secondary]') !== existing) {

                    toggle(e.target.querySelector('[data-nav-toggling]'), existing);

                }

            }

        }

        function togglingSecondaryHoverOff(e) {

            if (isDesktopNav() && canHover) {

                closeTimer = setTimeout(function () {

                    var target = e.target.querySelector('[data-nav-toggling]');
                    var expanded = target.getAttribute('aria-expanded') === 'true' ? true : false;

                    if (expanded) { toggle(e.target.querySelector('[data-nav-toggling]')); }

                }, 350);

            }

        }

        for (var i = 0; i < togglingSecondary.length; i++) {

            togglingSecondary[i].addEventListener('click', togglingSecondaryClick);
            togglingSecondary[i].addEventListener('keydown', togglingSecondaryKeyDown);
            togglingSecondary[i].closest('.nav__item').addEventListener('mouseenter', togglingSecondaryHover);
            togglingSecondary[i].closest('.nav__item').addEventListener('mouseleave', togglingSecondaryHoverOff);

        }

        // toggling tertiary clicks

        function togglingTertiaryClick(e) {

            if (!isDesktopNav()) {

                toggle(e.target);
                e.preventDefault();

            }

        }

        for (var j = 0; j < togglingTertiary.length; j++) {

            togglingTertiary[j].addEventListener('click', togglingTertiaryClick);

        }

        // toggling terrtiary desktop clicks

        function togglingTertiaryDesktopClick(e) {

            clearTimeout(tabHoverTimer);

            if (e.target.getAttribute('aria-expanded') === 'false') {

                var closestSecondaryNav = e.target.closest('[data-nav-secondary]');
                var existing = closestSecondaryNav.querySelector('[data-nav-tertiary].is-shown');

                // apply appropriate style

                closestSecondaryNav.parentNode.setAttribute('data-style', e.target.getAttribute('data-style'));

                toggle(e.target, existing);

            }

            e.preventDefault();

        }

        function togglingTertiaryDesktopKeyDown(e) {

            var keyPressed = getKeyPressed(e);

            if (keyPressed === 13 || keyPressed === 'Enter') { togglingTertiaryDesktopClick(e); }

        }

        function togglingTertiaryDesktopHover(e) {

            clearTimeout(tabHoverTimer);

            if (isDesktopNav() && canHover) {

                tabHoverTimer = setTimeout(function () { e.target.click(); }, 250);

            }

        }

        function togglingTertiaryDesktopHoverOut() {

            clearTimeout(tabHoverTimer);

        }

        for (var k = 0; k < togglingTertiaryDesktop.length; k++) {

            togglingTertiaryDesktop[k].addEventListener('click', togglingTertiaryDesktopClick);
            togglingTertiaryDesktop[k].addEventListener('keydown', togglingTertiaryDesktopKeyDown);
            togglingTertiaryDesktop[k].addEventListener('mouseenter', togglingTertiaryDesktopHover);
            togglingTertiaryDesktop[k].addEventListener('mouseleave', togglingTertiaryDesktopHoverOut);

        }

        // toggling quaternary clicks

        function togglingQuaternaryClick(e) {

            if (!isDesktopNav()) {

                toggle(e.target);
                e.preventDefault();

            }

        }

        function togglingQuaternaryKeyDown(e) {

            var keyPressed = getKeyPressed(e);

            if (keyPressed === 13 || keyPressed === 'Enter') { togglingQuaternaryClick(e); }

        }

        for (var l = 0; l < togglingQuaternary.length; l++) {

            togglingQuaternary[l].addEventListener('click', togglingQuaternaryClick);
            togglingQuaternary[l].addEventListener('keydown', togglingQuaternaryKeyDown);

        }

        // secondary close clicks

        function secondaryCloseClick(e) {

            var controls = e.target.getAttribute('aria-controls');
            var link = document.querySelector('[data-nav-toggling="secondary"][aria-controls="' + controls + '"]');
            link.click();

            unlockScroll();

            e.preventDefault();

        }

        function secondaryCloseKeyDown(e) {

            var keyPressed = getKeyPressed(e);

            if (keyPressed === 13 || keyPressed === 'Enter') { secondaryCloseClick(e); }

        }

        for (var m = 0; m < secondaryClose.length; m++) {

            secondaryClose[m].addEventListener('click', secondaryCloseClick);
            secondaryClose[m].addEventListener('keydown', secondaryCloseKeyDown);

        }

        // back element clicks

        function backElementClick(e) {

            var controls = e.target.getAttribute('aria-controls');
            var type = e.target.getAttribute('data-nav-back');

            if (type === 'tertiary|skip') {

                var linkOne = document.querySelector('[data-nav-toggling="quaternary"][aria-expanded="true"]');
                linkOne.click();

                var linkTwo = document.querySelector('[data-nav-toggling="tertiary"][aria-controls="' + controls + '"]');
                linkTwo.click();

            } else {

                var link = document.querySelector('[data-nav-toggling="' + type + '"][aria-controls="' + controls + '"]');
                link.click();

            }

            e.preventDefault();

        }

        for (var n = 0; n < backElements.length; n++) {

            backElements[n].addEventListener('click', backElementClick);

        }

        // document clicks

        document.addEventListener('click', function (e) {

            var link = document.querySelector('[data-nav-secondary].is-shown [data-nav-close]');
            if (!link) { return; }
            if (e.target !== element && !element.contains(e.target)) { link.click(); }

        });

    }

    // returnNavItemsWithQuaternary()

    function returnNavItemsWithQuaternary() {

        var result = [];

        for (var i = 0; i < togglingSecondary.length; i++) {

            if (togglingSecondary[i].parentNode.querySelectorAll('[data-nav-toggling="quaternary"]').length) { result.push(togglingSecondary[i].parentNode); }

        }

        return result;

    }

    // lockScroll()

    function lockScroll() {

        if (headroomInstance) {

            lastScrollTop = window.scrollY;
            body.style.marginTop = '-' + lastScrollTop + 'px';

        } else {

            window.scrollTo(0, 0);

        }

        html.classList.add('is-locked');

    }

    // unlockScroll()

    function unlockScroll() {

        if (headroomInstance) { headroomInstance.freeze(); }

        html.classList.remove('is-locked');

        if (headroomInstance) {

            body.style.marginTop = '0px';

            // COMMENTING OUT BELOW LINE TO FIX 241094
            //if (!isDesktopNav()) { window.scrollTo(0, lastScrollTop); }

            setTimeout(function () { headroomInstance.unfreeze(); }, 100);

        }

    }

    // debounce()

    function debounce(func, wait, immediate) {

        var timeout;

        return function executedFunction() {
            var context = this;
            var args = arguments;

            var later = function () {
                timeout = null;
                if (!immediate) { func.apply(context, args); }
            };

            var callNow = immediate && !timeout;

            clearTimeout(timeout);

            timeout = setTimeout(later, wait);

            if (callNow) { func.apply(context, args); }
        };

    }

    function getKeyPressed(e) {

        var key = e.key;

        if (key !== undefined) { return key; }

        var keyCode = e.keyCode;

        if (keyCode !== undefined) { return keyCode; }

    }

    return {
        init: init
    };

}();

nav.init();
